import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../../services/localization.service';

@Pipe({
  name: 'dayOfWeek'
})
export class DayOfWeekPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    let date = new Date(value);
    return date.toLocaleString(LocalizationService.getCurrentCultureCode(), { weekday: 'long' });
  }
}
